function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTinkloBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-866263fe-fd3e-432a-a56a-42e39ef77d96",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 186.88,
    height: 61.95,
    viewBox: "0 0 186.88 61.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "uuid-855e44bd-acbe-4f4a-841a-48905e17b978",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-22dd491e-079f-4f8f-978a-d350c4ac0d58",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-fe5703d4-4322-446c-b310-1e90958e188c",
    "data-name": "Layer 1-2",
    style: {
      fill: "#181E2E"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.1,50.25v-22.34H0v-9.84h7.1V6.38h11.35v11.7h8.68v9.84h-8.68v19.32c0,2.66,1.4,4.7,3.9,4.7,1.69,0,3.28-.62,3.9-1.24l2.39,8.51c-1.69,1.5-4.7,2.74-9.4,2.74-7.89,0-12.14-4.08-12.14-11.7Z",
    style: {
      fill: "#181E2E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.3,6.72C28.31,3,31.33,0,35.05,0c3.72,0,6.73,3.03,6.72,6.75,0,3.71-3.02,6.71-6.73,6.72-3.72-.02-6.73-3.04-6.75-6.75Zm1.14,54.16V18.06h11.26v42.81h-11.26Z",
    style: {
      fill: "#181E2E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.79,60.81v-25.88c0-5.96-3.1-7.98-7.89-7.98-3.87.04-7.48,1.92-9.75,5.05v28.81h-11.26V18h11.26v5.59c2.75-3.28,7.98-6.66,14.98-6.66,9.4,0,13.91,5.32,13.91,13.67v30.22h-11.25Z",
    style: {
      fill: "#181E2E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.92,60.76l-11.34-16.47-5.14,5.5v10.99h-11.27V1.64h11.26v35.37l16.22-19.06h13.83l-16.93,19.41,17.46,23.4h-14.08Z",
    style: {
      fill: "#181E2E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.59,39.26c0-12.14,8.51-22.43,22.6-22.43s22.69,10.28,22.69,22.43-8.51,22.51-22.69,22.51c-14.1,0-22.6-10.28-22.6-22.51Zm33.59,0c0-6.66-3.99-12.41-10.99-12.41s-10.9,5.76-10.9,12.41,3.9,12.5,10.9,12.5,10.99-5.76,10.99-12.5h0Z",
    style: {
      fill: "#181E2E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.49,60.76V1.64h11.25v59.12h-11.25Z",
    style: {
      fill: "#fcb900"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinkloBlack);
export default __webpack_public_path__ + "static/media/tinklo-black.08e6ffb4b923f2efd575ac32b253fa6e.svg";
export { ForwardRef as ReactComponent };